import React, { useEffect, useState, useRef } from 'react';
import { CTAButton } from './Shared';
import { Star, Lock, Eye } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
export const ProductShowcase = () => {
  const [viewers, setViewers] = useState(12);
  const viewersRef = useRef(12);
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    // Viewers logic
    const tick = () => {
      const current = viewersRef.current;
      const direction = Math.random();
      let next = current;
      if (direction < 0.45) {
        next = current + 1;
      } else if (direction < 0.9) {
        next = current - 1;
      } else {
        next = current + (Math.random() < 0.5 ? 2 : -2);
      }
      next = Math.max(5, Math.min(18, next));
      viewersRef.current = next;
      setViewers(next);
      const delay = 3000 + Math.random() * 4000;
      timeout = setTimeout(tick, delay);
    };
    let timeout = setTimeout(tick, 2000 + Math.random() * 3000);
    return () => clearTimeout(timeout);
  }, []);
  useEffect(() => {
    // Countdown logic
    const calculateTimeLeft = () => {
      const now = new Date();
      const midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0); // Next midnight
      const difference = midnight.getTime() - now.getTime();
      if (difference > 0) {
        setTimeLeft({
          hours: Math.floor(difference / (1000 * 60 * 60) % 24),
          minutes: Math.floor(difference / 1000 / 60 % 60),
          seconds: Math.floor(difference / 1000 % 60)
        });
      } else {
        // Reset to 24h if it hits 0
        setTimeLeft({
          hours: 23,
          minutes: 59,
          seconds: 59
        });
      }
    };
    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <section className="pt-8 md:pt-12 pb-12 px-4 bg-white border-b border-gray-100" data-id="element-348">
      <div className="max-w-6xl mx-auto" data-id="element-349">
        <div className="flex flex-col md:flex-row gap-8 md:gap-12 items-start" data-id="element-350">
          {/* Left Column - Image */}
          <div className="w-full md:w-1/2 bg-gray-50 rounded-2xl p-8 md:p-12 flex items-center justify-center border border-gray-100" data-id="element-351">
            <img src="https://cdn.magicpatterns.com/uploads/sv8DHjWWdQRJhD1Fvq2Rjv/De_0_a_influencer.png" alt="De 0 a Influencer" className="w-full max-w-[400px] drop-shadow-2xl hover:scale-105 transition-transform duration-500" data-id="element-352" />
          </div>

          {/* Right Column - Info */}
          <div className="w-full md:w-1/2 flex flex-col" data-id="element-353">
            <div className="flex items-center gap-2 text-gray-500 text-sm mb-3 font-opensans" data-id="element-354">
              <span className="text-xs" data-id="element-355">📄</span>
              <span data-id="element-356">+1.874 descargas verificadas</span>
            </div>

            <h1 className="font-montserrat font-black text-3xl md:text-5xl text-black leading-tight mb-4 uppercase" data-id="element-357">
              eBook: De 0 a Influencer
            </h1>

            <div className="flex items-center gap-2 mb-6" data-id="element-358">
              <div className="flex text-gold" data-id="element-359">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-360" />)}
              </div>
              <span className="font-opensans text-gray-700 font-medium text-sm md:text-base" data-id="element-361">
                4.9/5 (1.874 Reseñas)
              </span>
            </div>

            <div className="flex items-center gap-3 mb-6 flex-wrap" data-id="element-362">
              <span className="text-2xl text-gray-400 font-bold line-through decoration-2" data-id="element-363">
                $49.990
              </span>
              <span className="text-4xl font-montserrat font-black text-[#22c55e]" data-id="element-364">
                $14.990
              </span>
              <span className="bg-[#22c55e] text-white text-xs md:text-sm font-bold px-3 py-1.5 rounded-md uppercase tracking-wide flex items-center gap-1" data-id="element-365">
                <span className="text-xs" data-id="element-366">🏷️</span> Ahorrás 70%
              </span>
            </div>

            <div className="bg-gray-50 border border-gray-200 rounded-lg py-2.5 px-4 mb-6 inline-flex items-center gap-2 w-fit" data-id="element-367">
              <span data-id="element-368">🎁</span>
              <span className="font-opensans font-bold text-sm text-gray-800 flex items-center gap-2" data-id="element-369">
                70% OFF — La oferta termina en
                <div className="flex items-center gap-1 ml-1" data-id="element-370">
                  <span className="bg-black/10 rounded px-1.5 py-0.5 font-mono text-xs font-bold text-black" data-id="element-371">
                    {formatTime(timeLeft.hours)}
                  </span>
                  <span className="text-black/50 font-bold" data-id="element-372">:</span>
                  <span className="bg-black/10 rounded px-1.5 py-0.5 font-mono text-xs font-bold text-black" data-id="element-373">
                    {formatTime(timeLeft.minutes)}
                  </span>
                  <span className="text-black/50 font-bold" data-id="element-374">:</span>
                  <span className="bg-black/10 rounded px-1.5 py-0.5 font-mono text-xs font-bold text-black" data-id="element-375">
                    {formatTime(timeLeft.seconds)}
                  </span>
                </div>
              </span>
            </div>

            <div className="mb-4 w-full" data-id="element-376">
              <CTAButton text="Descargar Ahora" subtext="Acceso inmediato. Empezás hoy." className="[&>button]:!bg-[#22c55e] [&>button]:hover:!bg-[#16a34a] [&>button]:!shadow-[0_8px_0px_#15803d] [&>button]:!border-[#16a34a] [&>button]:!max-w-full" data-id="element-377" />
            </div>

            <div className="flex items-center justify-center md:justify-start gap-2 text-gray-600 text-sm font-opensans mb-8" data-id="element-378">
              <span className="relative flex h-3 w-3" data-id="element-379">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-coral opacity-75" data-id="element-380"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-coral" data-id="element-381"></span>
              </span>
              <span data-id="element-382">
                <AnimatePresence mode="popLayout" data-id="element-383">
                  <motion.strong key={viewers} initial={{
                  y: 8,
                  opacity: 0
                }} animate={{
                  y: 0,
                  opacity: 1
                }} exit={{
                  y: -8,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeOut'
                }} className="text-black inline-block" data-id="element-384">
                    {viewers}
                  </motion.strong>
                </AnimatePresence>{' '}
                personas están viendo este producto ahora mismo.
              </span>
            </div>

            <div className="bg-[#f8fafc] border border-gray-200 rounded-xl p-6 mb-8" data-id="element-385">
              <div className="flex items-center gap-3 mb-4" data-id="element-386">
                <Lock className="w-5 h-5 text-gold" data-id="element-387" />
                <h3 className="font-montserrat font-bold text-gray-900 text-sm md:text-base" data-id="element-388">
                  Compra rápida, segura y sin complicaciones
                </h3>
              </div>
              <ul className="space-y-3 text-sm font-opensans text-gray-600" data-id="element-389">
                <li className="flex items-start gap-2" data-id="element-390">
                  <span className="text-gray-400 mt-1" data-id="element-391">•</span>
                  <span data-id="element-392">
                    <strong className="text-gray-900" data-id="element-393">Pago protegido</strong>{' '}
                    mediante Mercado Pago.
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-394">
                  <span className="text-gray-400 mt-1" data-id="element-395">•</span>
                  <span data-id="element-396">
                    <strong className="text-gray-900" data-id="element-397">
                      Descarga inmediata
                    </strong>{' '}
                    apenas se acredita el pago.
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-398">
                  <span className="text-gray-400 mt-1" data-id="element-399">•</span>
                  <span data-id="element-400">
                    <strong className="text-gray-900" data-id="element-401">
                      Acceso de por vida
                    </strong>{' '}
                    al programa para verlo cuando quieras.
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-402">
                  <span className="text-gray-400 mt-1" data-id="element-403">•</span>
                  <span data-id="element-404">
                    <strong className="text-gray-900" data-id="element-405">Compatible</strong> con
                    cualquier celular, PC o tablet.
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-406">
                  <span className="text-gray-400 mt-1" data-id="element-407">•</span>
                  <span data-id="element-408">
                    <strong className="text-gray-900" data-id="element-409">+1.874 personas</strong>{' '}
                    ya compraron este programa y lo están usando.
                  </span>
                </li>
              </ul>
            </div>

            <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 mb-8" data-id="element-410">
              <p className="font-montserrat font-bold text-sm text-amber-900 mb-3 flex items-center gap-2" data-id="element-411">
                🎁 Incluidos GRATIS con tu compra:
              </p>
              <div className="flex flex-col sm:flex-row gap-3" data-id="element-412">
                <div className="flex items-center gap-3 flex-1 bg-white rounded-lg p-2.5 border border-amber-100" data-id="element-413">
                  <img src="https://cdn.magicpatterns.com/uploads/eLX6bS2bbuBLcXqCQAitkN/planner_de_creadora_Ebook.png" alt="Planner de Creadora" className="w-12 h-auto shrink-0 drop-shadow-md" data-id="element-414" />
                  <div data-id="element-415">
                    <p className="font-montserrat font-bold text-xs text-black leading-tight" data-id="element-416">
                      Planner de Creadora
                    </p>
                    <div className="flex items-center gap-1.5" data-id="element-417">
                      <span className="text-[10px] text-gray-400 line-through" data-id="element-418">
                        $4.990
                      </span>
                      <span className="text-[10px] font-bold text-[#22c55e] uppercase tracking-wider" data-id="element-419">
                        Gratis
                      </span>
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-3 flex-1 bg-white rounded-lg p-2.5 border border-amber-100" data-id="element-420">
                  <img src="https://cdn.magicpatterns.com/uploads/sANQ8B976TBqQKeve7FP5o/100_ideas_ebook.png" alt="100 Ideas de Contenido" className="w-12 h-auto shrink-0 drop-shadow-md" data-id="element-421" />
                  <div data-id="element-422">
                    <p className="font-montserrat font-bold text-xs text-black leading-tight" data-id="element-423">
                      100 Ideas de Contenido
                    </p>
                    <div className="flex items-center gap-1.5" data-id="element-424">
                      <span className="text-[10px] text-gray-400 line-through" data-id="element-425">
                        $8.990
                      </span>
                      <span className="text-[10px] font-bold text-[#22c55e] uppercase tracking-wider" data-id="element-426">
                        Gratis
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex justify-center md:justify-start items-center gap-5" data-id="element-427">
              <img src="https://cdn.magicpatterns.com/uploads/3gG2f1UKZEeyMV6ukZ9XLU/MP_RGB_HANDSHAKE_color_horizontal.svg" alt="Mercado Pago" className="h-12 object-contain" data-id="element-428" />
              <img src="https://cdn.magicpatterns.com/uploads/qyQW7QxRvCJm4Rtgo1Nq9r/visa-brandmark-blue-1960x622.webp" alt="Visa" className="h-5 object-contain" data-id="element-429" />
              <img src="https://cdn.magicpatterns.com/uploads/wmF7rZEFfiNHBgR17qRCkv/ma_symbol.svg" alt="Mastercard" className="h-7 object-contain" data-id="element-430" />
            </div>
          </div>
        </div>
      </div>
    </section>;
};